export const searchArchive = function (el) {
    el.addEventListener("keyup", function (evt) {
        const query = this.value;
        if (query.length > 0) {
            history.pushState(null, "Search: " + query, "/archive/?q=" + query);
            performSearch(query);
        } else {
            history.pushState(null, "Search", "/archive/");
            performSearch("");

            document
                .querySelectorAll(".archive__item")
                .forEach(function (item) {
                    item.classList.remove("archive__item--hidden");
                });
            document.querySelector(".archive__item--no-results").style.display =
                "none";
        }
    });

    const archive = document.querySelector(".archive-section");
    if (window.location.search.length) {
        const query = decodeURI(window.location.search.substring(3));
        performSearch(query);
        el.value = query;
    }
    archive.style.opacity = 1;
};

const performSearch = function (query) {
    let matches = 0;

    document.querySelectorAll(".archive__item").forEach(function (item) {
        if (item.dataset.filters.search(new RegExp(query, "g")) === -1) {
            item.classList.add("archive__item--hidden");
        } else {
            matches++;
            item.classList.remove("archive__item--hidden");
        }
    });

    if (matches <= 0) {
        document.querySelector(".archive__item--no-results").style.display =
            "block";
    } else {
        document.querySelector(".archive__item--no-results").style.display =
            "none";
    }
};
